module.exports = __webpack_public_path__ + "img/switch_img2_msg1.6b2cf3a4.png";